import React from 'react';
import { ShieldCheck, BadgeCheck, Handshake, UsersRound, Layers } from 'lucide-react';

export const ValuesBand = () => (
  <div className="values-band" data-testid="values-band"><div className="site-container values-inner">
    {[[ShieldCheck, 'Segurança'], [BadgeCheck, 'Qualidade'], [Handshake, 'Confiança'], [UsersRound, 'Parceria'], [Layers, 'Solução completa']].map(([Icon, label], index) => (
      <div key={label} data-testid={`brand-value-${index}`}><Icon size={23} strokeWidth={1.5} aria-hidden="true" /><span>{label}</span></div>
    ))}
  </div></div>
);